// plugins/toast.js
import { reactive } from "vue";

export default {
  install(app) {
    const state = reactive({
      toasts: [],
      config: {
        position: "top", // top or bottom
        duration: 5000,
      }
    });

    function showToast(options = {}) {        
      const id = Date.now() + Math.random();

      const toast = {
        id,
        title: "",
        message: "",
        type: "success", // success | error
        alignment: "right", // left | center | right
        position: state.config.position, // top | bottom
        duration: state.config.duration,
        ...options,
      };

      state.toasts.push(toast);

      setTimeout(() => {
        state.toasts = state.toasts.filter(t => t.id !== id);
      }, toast.duration);
    }

    // Provide store + method
    app.provide("toastStore", state);
    app.provide("toast", showToast);

    // Global property (most convenient)
    app.config.globalProperties.$toast = showToast;
  }
};
